const API_VERSION = process.env.REACT_APP_API_V || "1";
const API_BASE = `/v${API_VERSION}`;

// User
export const API_USERS_SIGNUP = `${API_BASE}/users/signup`;
export const API_SIGNUP_EMAIL_SEND_CODE = `${API_BASE}/users/signup-email/send-code`;
export const API_SIGNUP_EMAIL_VERIFY_CODE = `${API_BASE}/users/signup-email/verify-code`;
export const API_USERS_SIGNIN = `${API_BASE}/users/signin`;
export const API_USERS_LIST = `${API_BASE}/users`;
export const API_USERS_PROFILE = `${API_BASE}/users/:id`;
export const API_SWITCH_USER = `${API_BASE}/users/switch-user`;
export const API_USER_DELETE = `${API_BASE}/users/delete`;
export const API_USER_LOGOUT = `${API_BASE}/users/logout`;
export const API_USER_LOGIN_AS = `${API_BASE}/users/login-as`;
export const API_USER_LOGOUT_FROM = `${API_BASE}/users/logout-from`;
export const API_USER_STATUS_UPDATE = `${API_BASE}/users`;
export const API_USER_BREAK_UPDATE = `${API_BASE}/users/:id/break`;
export const API_USER_PASSWORD_RESET_MAIL= `${API_BASE}/users/password-reset-mail`;
export const API_VERIFY_OTP = `${API_BASE}/users/verify-otp`;
export const API_RESET_PASSWORD = `${API_BASE}/users/reset-password`;
export const API_VERIFY_EMAIL = `${API_BASE}/users/verify-email`;
export const API_RESEND_EMAIL_VERIFICATION = `${API_BASE}/users/resend-email-verification`;
export const API_GET_USER = `${API_BASE}/users`;


//queue operation(call-group)

export const CALL_GROUP_REMOVE_AGENT = `${API_BASE}/agent-group/remove-agent`;
export const CALL_GROUP_ADD_AGENT = `${API_BASE}/agent-group`;

// Call Strategies Master
export const API_CALL_STRATEGIES_MASTER_LIST = `${API_BASE}/strategies-master`;

//voice-plan
export const API_VOICE_PLAN_LIST = `${API_BASE}/voice-plan`;
export const API_VOICE_PLAN_CREATE = `${API_BASE}/voice-plan/create`;
export const API_VOICE_PLAN_EDIT = `${API_BASE}/voice-plan/update`;
export const API_VOICE_PLAN_DELETE = `${API_BASE}/voice-plan/delete`;


// Company
export const API_COMPANY_LIST = `${API_BASE}/companies`;
export const API_COMPANY_CREATE = `${API_BASE}/companies`;
export const API_COMPANY_PROFILE = `${API_BASE}/companies/:id`;
export const API_PARENT_COMPANY_LICENCE = `${API_BASE}/companies/parent-licence`;
export const API_COMPANY_DELETE = `${API_BASE}/companies/delete/:id`;

// Call Centres
export const API_CALL_CENTRE_LIST = `${API_BASE}/call-centres`;
export const API_CALL_CENTRE_CREATE = `${API_BASE}/call-centres`;
export const API_CALL_CENTRE_PROFILE = `${API_BASE}/call-centres/:id`;
export const API_CALL_CENTRE_USERS_LIST = `${API_BASE}/call-centres/:id/users`;
export const API_PARENT_CALL_CENTER_LICENCE = `${API_BASE}/companies/parent-licence`;
export const API_CALL_CENTRE_DELETE = `${API_BASE}/call-centres/delete/:id`;
export const API_CALL_CENTRE_ADMIN_ALERT = `${API_BASE}/call-centres/admin-alert`;

// Trunks
export const API_TRUNKS_LIST = `${API_BASE}/trunks`;
export const API_TRUNKS_CREATE = `${API_BASE}/trunks`;
export const API_TRUNKS_EDIT = `${API_BASE}/trunks/:id`;
export const API_TRUNKS_DELETE = `${API_BASE}/trunks/delete`;

// Codecs
export const API_CODECS_LIST = `${API_BASE}/codecs`;


// Manage Groups
export const API_MANAGE_GROUP_CREATE = `${API_BASE}/groups`; 
export const API_MANAGE_GROUP_LISTING = `${API_BASE}/groups`;  
export const API_MANAGE_GROUP_DELETE = `${API_BASE}/groups/delete`; 
export const API_MANAGE_GROUP_UPDATE = (id) => `${API_BASE}/groups/${id}`;
export const API_GET_COMPANY_GROUP = (id) => `${API_BASE}/groups/getByGroupId/${id}`;
export const API_BULK_GROUP_ADD = `${API_BASE}/groups/bulk-add`;
export const API_BULK_GROUP_DELETE = `${API_BASE}/groups/bulk-delete`;
export const API_GROUP_MEMBERS = (id) => `${API_BASE}/groups/${id}/users`;



// Manage Locations
export const API_MANAGE_LOCATIONS_CREATE = `${API_BASE}/locations`;          
export const API_MANAGE_LOCATIONS_LIST = `${API_BASE}/locations`;            
export const API_MANAGE_LOCATIONS_UPDATE = (id) => `${API_BASE}/locations/${id}`;
export const API_GET_COMPANY_LOCATION = (id) => `${API_BASE}/locations/getByLocationId/${id}`;
export const API_MANAGE_LOCATIONS_DELETE = `${API_BASE}/locations/delete`;
export const API_BULK_LOCATION_ADD = `${API_BASE}/locations/bulk-add`;
export const API_BULK_LOCATION_DELETE = `${API_BASE}/locations/bulk-delete`;



//Manage Dialer
export const API_MANAGE_DIALER_CREATE = `${API_BASE}/voice-dialers`;
export const API_MANAGE_DIALER_LISTING = `${API_BASE}/voice-dialers`;
export const API_MANAGE_DIALER_DETAIL = (id) => `${API_BASE}/voice-dialers/${id}`;
export const API_MANAGE_DIALER_UPDATE = (id) => `${API_BASE}/voice-dialers/${id}`;
export const API_MANAGE_DIALER_DELETE = `${API_BASE}/voice-dialers/delete`;



//Country Codes
export const API_COUNTRY_CODES_LIST = `${API_BASE}/country-codes`;

// Country Code Directions Master (SuperAdmin)
export const API_COUNTRY_CODE_DIRECTIONS_MASTER_LIST = `${API_BASE}/country-code-directions-master`;
export const API_COUNTRY_CODE_DIRECTIONS_MASTER_CREATE = `${API_BASE}/country-code-directions-master`;
export const API_COUNTRY_CODE_DIRECTIONS_MASTER_UPDATE = (id) => `${API_BASE}/country-code-directions-master/update/${id}`;
export const API_COUNTRY_CODE_DIRECTIONS_MASTER_DELETE = (id) => `${API_BASE}/country-code-directions-master/delete/${id}`;
export const API_COUNTRY_CODE_DIRECTIONS_MASTER_SINGLE = (id) => `${API_BASE}/country-code-directions-master/${id}`;
export const API_COUNTRY_CODE_DIRECTIONS_MASTER_AVAILABLE_COUNTRIES = `${API_BASE}/country-code-directions-master/available-countries`;

// User Country Code Directions (assigned per company / call-centre)
export const API_USER_COUNTRY_CODE_DIRECTIONS_ME = `${API_BASE}/user-country-code-directions/me`;
export const API_USER_COUNTRY_CODE_DIRECTIONS_BY_COMPANY = (companyId) => `${API_BASE}/user-country-code-directions/company/${companyId}`;
export const API_USER_COUNTRY_CODE_DIRECTIONS_BY_CALL_CENTRE = (callcenterId) => `${API_BASE}/user-country-code-directions/call-centre/${callcenterId}`;
export const API_USER_COUNTRY_CODE_DIRECTIONS_BY_AGENT = (agentId) => `${API_BASE}/user-country-code-directions/agent/${agentId}`;
export const API_USER_COUNTRY_CODE_DIRECTIONS_BY_AGENT_IDS = `${API_BASE}/user-country-code-directions/agents/bulk`;

//Numbers
export const API_TO_GET_REMOVE_NUMBERS = `${API_BASE}/numbers/remove`;


// Numbers
export const API_NUMBERS_UPLOAD = `${API_BASE}/numbers/upload-numbers`;
export const API_NUMBERS_CREATE = `${API_BASE}/numbers/`;
export const API_NUMBERS_LIST = `${API_BASE}/numbers`;
export const API_NUMBER_DELETE = `${API_BASE}/numbers/delete`;
export const API_NUMBER_EDIT = `${API_BASE}/numbers/:id`;
export const API_DID_NUMBERS = `${API_BASE}/numbers/did`;
export const API_NUMBER_STATUS = `${API_BASE}/numbers/number-status`;
export const API_BULK_ASSIGN_DID = `${API_BASE}/numbers/bulk/assign-did`;
export const API_INDIVIDUAL_ASSIGN_DID = `${API_BASE}/numbers/individual/assign-did`;
export const API_NUMBER_FILE_LIST = `${API_BASE}/number-filelist/`;
export const API_NUMBER_FILE_LIST_DELETE = `${API_BASE}/number-filelist/delete`;
export const API_NUMBER_STATUS_CHANGE = `${API_BASE}/numbers/status-change`;
export const API_NUMBER_EDIT_BULK = `${API_BASE}/numbers/update-bulk`;
export const API_DID_MAPPING = `${API_BASE}/numbers/did-mapping`;
export const API_TO_ALLOCATE_NUMBERS = `${API_BASE}/numbers/to-allocate`;
export const API_ALLOCATED_NUMBERS = `${API_BASE}/numbers/allocated`;
export const API_REMOVE_NUMBERS = `${API_BASE}/numbers/remove`;
export const API_INBOUND_ROUTING = `${API_BASE}/numbers/inbound-routing`;
export const API_INBOUND_ROUTING_CLEAR = `${API_BASE}/numbers/inbound-routing/clear`;
export const API_INBOUND_ROUTING_REMOVE = `${API_BASE}/numbers/inbound-routing/remove`;
export const API_CALL_CENTRE_DEFAULT_CLI = `${API_BASE}/numbers/call-centre/default-cli`;

// Agents
export const API_AGENTS_LIST = `${API_BASE}/agents/`;
export const AGENT_GROUP_CREATE = `${API_BASE}/agents/`;
export const API_AGENT_DELETE = `${API_BASE}/agents/delete`;
export const API_AGENT_UPDATE = `${API_BASE}/agents`;
export const API_AGENT_BREAK_ADD = `${API_BASE}/agents/break`;
export const API_AGENT_PARENT_ID = `${API_BASE}/agents/parent/:id/:user`;
export const API_AGENT_BULK_LOGOUT = `${API_BASE}/agents/bulk-logout`;
export const API_AGENT_BULK_UPLOAD = `${API_BASE}/agents/bulk-upload`;
export const API_AGENT_SCHEDULE = `${API_BASE}/agents/agent_schedule`;
export const API_AGENT_FILE_LIST = `${API_BASE}/agent-filelist/`;
export const API_AGENT_FILE_LIST_DELETE = `${API_BASE}/agent-filelist/delete`;
export const API_AGENT_FILE_LIST_DOWNLOAD = `${API_BASE}/agent-filelist/download`;
export const API_AGENTS_GROUP_OWNERS = `${API_BASE}/agents/group_owners/:id`;
export const API_AGENT_IDLE_STATS = `${API_BASE}/agents/idle-stats`;
export const API_AGENT_IDLE_STATS_GET = `${API_BASE}/agents/idle-stats`;
export const API_AGENT_AVAILABLE_INBOUND_NUMBERS = `${API_BASE}/agents/available-inbound-numbers`;
export const API_AGENT_MY_ASSIGNED_CLIS = `${API_BASE}/agents/me/assigned-clis`;
export const API_AGENT_AVAILABLE_INBOUND_NUMBERS_BY_ID = `${API_BASE}/agents/:id/available-inbound-numbers`;
export const API_AGENT_CLI_ALLOCATIONS_SYNC = `${API_BASE}/agents/:id/cli-allocations/sync`;
// Mobile-profile dialer
export const API_AGENT_MOBILE_DIAL = `${API_BASE}/agents/mobile-dial`;
export const API_AGENT_MOBILE_HANGUP = `${API_BASE}/agents/mobile-hangup`;

// Incoming Summary
export const API_INCOMING_SUMMARY_LIST = `${API_BASE}/incoming-summary/`;
export const API_INCOMING_SUMMARY_DATE_RANGE_LIST = `${API_BASE}/incoming-summary/date-range`;

// Download Report
export const DOWNLOAD_REPORT = `${API_BASE}/download-report/`;
export const CDR_REPORT = `${API_BASE}/cdr-reports/cdr/`;

// Agent Groups
export const API_AGENT_GROUPS_LIST = `${API_BASE}/agent-group/`;
export const API_AGENT_GROUP_DELETE = `${API_BASE}/agent-group/delete`;
export const API_AGENT_GROUP_EXTENSION = `${API_BASE}/extension`;
export const API_AGENT_GROUP_STRATEGY = `${API_BASE}/call-stratergy`;
export const API_AGENT_GROUP_UPDATE = `${API_BASE}/agent-group/update`;
export const API_AGENT_GROUP_ASSIGNED_AGENTS = `${API_BASE}/agent-group/:id/assigned-agents`;

export const API_AGENT_GROUP_AVAILABLE_INBOUND_NUMBERS = `${API_BASE}/agent-group/:id/available-inbound-numbers`;
export const API_AGENT_GROUP_CLI_ALLOCATIONS_SYNC = `${API_BASE}/agent-group/:id/cli-allocations/sync`;

export const API_SINGLE_AGENT_GROUP = `${API_BASE}/agent-group/:id`;
//incoming-report
export const API_INCOMING_REPORT_BY_DID_LIST = `${API_BASE}/incoming-report/get-report`;
export const API_ALL_INCOMING_REPORT = `${API_BASE}/incoming-report/get-report/incoming`;


//download-report


// Extensions
export const API_EXTENSION = `${API_BASE}/extension`;

// Manage Queues
export const API_QUEUES = `${API_BASE}/queue`;
export const API_QUEUE_DELETE = `${API_BASE}/queue/delete`;
export const API_QUEUE_UPDATE = `${API_BASE}/queue/`;

// IVR
export const API_IVR_CREATE = `${API_BASE}/call-centres/:cid/ivr`;
export const API_IVR_LIST = `${API_BASE}/call-centres/:cid/ivr`;
export const API_IVR_DELETE = `${API_BASE}/call-centres/:cid/ivr/delete`;
export const API_IVR_EDIT = `${API_BASE}/call-centres/:cid/ivr/:id`;
export const API_IVR_SETTINGS = `${API_BASE}/ivr/settings`;
export const API_IVR_VIEW = `${API_BASE}/call-centres/:cid/ivr/:id`;

// Languages / Prompts
export const API_GET_LANGUAGES = `${API_BASE}/language`;
export const API_CREATE_PROMPTS = `${API_BASE}/prompt`;
export const API_GET_PROMPTS = `${API_BASE}/prompt`;
export const API_PROMPT_ACTIVE_LIST = `${API_BASE}/prompt`;

// MOH (Music On Hold) Management
export const API_MOH = `${API_BASE}/moh`;
export const API_MOH_CREATE = `${API_BASE}/moh`;
export const API_MOH_LIST = `${API_BASE}/moh`;
export const API_MOH_ACTIVE = `${API_BASE}/moh/active`;
export const API_MOH_UPDATE_STATUS = `${API_BASE}/moh/:id`;
export const API_MOH_DELETE = `${API_BASE}/moh/delete`;

// Operators
export const API_OPERATORS_LIST = `${API_BASE}/operators`;

// Timezones
export const API_TIMEZONES_LIST = `${API_BASE}/timezones`;

// Data Center
export const API_DATA_CENTER_LIST = `${API_BASE}/data-center`;
export const API_DATA_CENTER_CREATE = `${API_BASE}/data-center/create`;
export const API_DATA_CENTER_EDIT = `${API_BASE}/data-center/:id`;
export const API_DATA_CENTER_DELETE = `${API_BASE}/data-center/delete`;

// States
export const API_STATES_LIST = `${API_BASE}/states`;

// Cities
export const API_CITIES_LIST = `${API_BASE}/city`;

// Server Management
export const API_SERVER_MANAGEMENT_CREATE = `${API_BASE}/server-management/create`;
export const API_SERVER_MANAGEMENT_LIST = `${API_BASE}/server-management`;
export const API_SERVER_MANAGEMENT_DELETE = `${API_BASE}/server-management/delete`;
export const API_SERVER_MANAGEMENT_EDIT = `${API_BASE}/server-management/:id`;

// Module
export const API_MODULE_CREATE = `${API_BASE}/module`;
export const API_MODULE_LIST = `${API_BASE}/module`;
export const API_MODULE_DELETE = `${API_BASE}/module/delete`;
export const API_MODULE_EDIT = `${API_BASE}/module/:id`;
export const API_ACL_SETTING_CREATE = `${API_BASE}/acl-settings/create`;
export const API_ACL_SETTING_LIST = `${API_BASE}/acl-settings`;
export const API_ACL_SETTING_EDIT = `${API_BASE}/acl-settings/:id`;
export const API_PARENT_ACL_SETTINGS = `${API_BASE}/acl-settings/parent`;
export const API_ACL_SETTING_DELETE = `${API_BASE}/acl-settings/delete`;

//remark stattus
export const API_REMARK_STATUS_CREATE = `${API_BASE}/remark-status/create`;
export const API_REMARK_STATUS_LIST = `${API_BASE}/remark-status`;
export const API_REMARK_STATUS_DELETE = `${API_BASE}/remark-status/delete`;
export const API_REMARK_STATUS_EDIT = `${API_BASE}/remark-status/:id`;

//remark
export const API_REMARK_CREATE = `${API_BASE}/remarks/create`;
export const API_REMARK_LIST = `${API_BASE}/remarks`;

// Agent_Announcement
export const API_AGENT_ANNOUNCEMENT_LIST = `${API_BASE}/agent-announcements`;
export const API_AGENT_ANNOUNCEMENT_CREATE = `${API_BASE}/agent-announcements/create`;
export const API_AGENT_ANNOUNCEMENT_EDIT = `${API_BASE}/agent-announcements/update/:id`;
export const API_AGENT_ANNOUNCEMENT_DELETE = `${API_BASE}/agent-announcements/delete`;
export const API_AGENT_ANNOUNCEMENT_SINGLE = `${API_BASE}/agent-announcements/:id`;

// Journey Operation
export const API_JOURNEY_OPERATION_LIST = `${API_BASE}/user-journey`;

// Export Operation
export const API_LIST_EXPORT = `${API_BASE}/export/:model`;

// User Credits
export const API_CREDITS = `${API_BASE}/credits/:id`;
export const API_CREDITS_GET = `${API_BASE}/credits`;

//DID History
export const API_ALLOCATED_DID = `${API_BASE}/did-allocate-history/`;
export const API_REMOVE_DID = `${API_BASE}/did-remove-history`;

// Company Credits
export const API_COMPANY_CREDITS = `${API_BASE}/credits/company/:id`;

// Outgoing Calls
export const API_OUTGOING_CALLS = `${API_BASE}/outgoing-calls`;

// Voice Campaigns
export const API_VOICE_CAMPAIGNS_LIST = `${API_BASE}/voice-campaigns`;
export const API_VOICE_CAMPAIGNS_CREATE = `${API_BASE}/voice-campaigns`;
export const API_VOICE_CAMPAIGNS_GET_ONE = `${API_BASE}/voice-campaigns/:id`;
export const API_VOICE_CAMPAIGNS_UPDATE = `${API_BASE}/voice-campaigns/:id`;

// Break
export const API_BREAK_LIST = `${API_BASE}/breaks`;
export const API_BREAK_UPDATE = `${API_BASE}/breaks/:id`;
export const API_BREAK_CREATE = `${API_BASE}/breaks`;
export const API_BREAK_DELETE = `${API_BASE}/breaks/delete`;
export const API_BREAK_GET_ONE = `${API_BASE}/breaks/:id`;

// Webhook
export const API_WEBHOOK_LIST = `${API_BASE}/webhook`;
export const API_WEBHOOK_UPDATE = `${API_BASE}/webhook/:id`;
export const API_WEBHOOK_CREATE = `${API_BASE}/webhook`;
export const API_WEBHOOK_DELETE = `${API_BASE}/webhook/delete`;
export const API_WEBHOOK_GET_ONE = `${API_BASE}/webhook/:id`;
export const API_WEBHOOK_REQUEST_PARAMETERS = `/v2/webhook/request-parameters`;


// Sms Webhook
export const API_SMSWEBHOOK_LIST = `${API_BASE}/sms-webhook`;
export const API_SMSWEBHOOK_UPDATE = `${API_BASE}/sms-webhook/:id`;
export const API_SMSWEBHOOK_CREATE = `${API_BASE}/sms-webhook`;
export const API_SMSWEBHOOK_DELETE = `${API_BASE}/sms-webhook/delete`;
export const API_SMSWEBHOOK_GET_ONE = `${API_BASE}/sms-webhook/:id`;

// Api Webhook
export const API_APIWEBHOOK_LIST = `${API_BASE}/api-webhook`;
export const API_APIWEBHOOK_UPDATE = `${API_BASE}/api-webhook/:id`;
export const API_APIWEBHOOK_CREATE = `${API_BASE}/api-webhook`;
export const API_APIWEBHOOK_DELETE = `${API_BASE}/api-webhook/delete`;
export const API_APIWEBHOOK_GET_ONE = `${API_BASE}/api-webhook/:id`;
export const API_APIWEBHOOK_REQUEST_PARAMETERS_LIST = `${API_BASE}/api-webhook-request-parameters`;

// Contact Groups
export const API_CONTACT_GROUP_LIST = `${API_BASE}/contact-groups`;
export const API_CONTACT_GROUP_CREATE = `${API_BASE}/contact-groups`;
export const API_CONTACT_GROUP_DELETE = `${API_BASE}/contact-groups/:id`;
export const API_CONTACT_GROUP_MEMBER_UPLOAD = `${API_BASE}/contact-groups/import/:id`;

// Contact Group Members
export const API_CONTACT_GROUP_MEMBERS_LIST = `${API_BASE}/contact-group-member`;
export const API_CONTACT_GROUP_MEMBERS_UPDATE = `${API_BASE}/contact-group-member/:id`;
export const API_CONTACT_GROUP_MEMBERS_CREATE = `${API_BASE}/contact-group-member`;
export const API_CONTACT_GROUP_MEMBERS_DELETE = `${API_BASE}/contact-group-member/delete`;
export const API_CONTACT_GROUP_MEMBERS_GET_ONE = `${API_BASE}/contact-group-member/:id`;
export const API_CONTACT_GROUP_MEMBERS_UNDER_ONE_GROUP = `${API_BASE}/contact-group-member/contact-group/:id`;
export const API_CONTACT_GROUP_MEMBERS_UPLOAD = `${API_BASE}/contact-group-member/upload/file`;
export const API_ALL_CONTACTS_LIST = `${API_BASE}/contact-group-member/all/members`;
export const API_CONTACT_GROUP_MEMBER_BY_NUMBER = `${API_BASE}/contact-group-member/get-member-by-number/:number`;

// Scripts
export const API_SCRIPTS_LIST = `${API_BASE}/scripts`;

// Tts
export const API_TTS_LIST = `${API_BASE}/tts`;
export const API_TTS_CREATE = `${API_BASE}/tts`;
export const API_TTS_DELETE = `${API_BASE}/tts/:id`;
export const API_TTS_UPDATE = `${API_BASE}/tts/:id`;

//TTS Plans
export const API_TTS_PLANS_LIST = `${API_BASE}/tts-plans`;
export const API_TTS_PLANS_CREATE = `${API_BASE}/tts-plans`;
export const API_TTS_PLANS_UPDATE = `${API_BASE}/tts-plans/:id`;

//TTS Credits
export const API_TTS_CREDITS = `${API_BASE}/tts-credits/:id`;

// User Breaks
export const USER_BREAKS_LIST = `${API_BASE}/user-breaks`;
export const USER_BREAKS_CREATE = `${API_BASE}/user-breaks/create`;
export const USER_BREAKS_EDIT = `${API_BASE}/user-breaks/:id`;
export const API_AGENT_BREAK_EXCEEDED_STATS = `${API_BASE}/user-breaks/exceeded-stats`;

export const LICENCE_HISTORY_LIST = `${API_BASE}/licence-history`;

export const AGENT_CALL_CONNECT_LIST = `${API_BASE}/agent-call-connect`;


//Flash Message
export const API_FLASH_MESSAGE_LIST = `${API_BASE}/flash-message`;
export const API_FLASH_MESSAGE_CREATE = `${API_BASE}/flash-message/create`;
export const API_FLASH_MESSAGE_EDIT = `${API_BASE}/flash-message`;
export const API_FLASH_MESSAGE_DELETE = `${API_BASE}/flash-message/delete`;

export const API_DASHBOARD_STATS = `${API_BASE}/dashboard-stats`;
export const API_DASHBOARD_OUTBOUND_CAMPAIGNS_STATS = `${API_BASE}/dashboard-stats/outbound-campaigns`;
export const API_DASHBOARD_USER_WISE_CAMPAIGN_SUMMARY_STATS = `${API_BASE}/dashboard-stats/user-wise-campaign-summary`;
export const API_DASHBOARD_TODAY_RUNNING_CAMPAIGN_SUMMARY_STATS = `${API_BASE}/dashboard-stats/today-running-campaigns`;
export const API_DASHBOARD_OUTGOING_CALLS_SUMMARY = `${API_BASE}/dashboard-stats/outgoing-calls-summary`;
export const API_DASHBOARD_INCOMING_SUMMARY = `${API_BASE}/dashboard-stats/incoming-summary`;
export const API_DASHBOARD_IVR_LISTING = `${API_BASE}/dashboard-stats/ivr-listing`;

export const API_AGENT_DASHBOARD_CAMPAIGNS = `${API_BASE}/agents/dashboard/active-campaigns/agent-data`;
export const API_AGENT_DASHBOARD_CALLS = `${API_BASE}/agents/dashboard/agent-calls/:id`;

export const API_CALLS_CREATE = `${API_BASE}/calls`;

//notification
export const API_NOTIFICATION_LIST = `${API_BASE}/notifications`;
export const API_NOTIFICATION_CREATE = `${API_BASE}/notifications/create`;
export const API_NOTIFICATION_EDIT = `${API_BASE}/notifications/update/:id`;
export const API_NOTIFICATION_DELETE = `${API_BASE}/notifications/delete`;
export const API_NOTIFICATION_SINGLE = `${API_BASE}/notifications/:id`;
export const API_NOTIFICATION_ASSIGN_TO_AGENT = `${API_BASE}/notifications/assign-to-agents/`;
export const API_NOTIFICATION_ASSIGNED_TO_AGENT = `${API_BASE}/notifications/assigned-to-agents/`;
export const API_NOTIFICATION_UNASSIGN_FROM_AGENT = `${API_BASE}/notifications/remove-from-agents/`;


// Call Scripts
export const API_CALL_SCRIPT_LIST   = `${API_BASE}/scripts`;
export const API_CALL_SCRIPT_CREATE = `${API_BASE}/scripts/create`;
export const API_CALL_SCRIPT_EDIT   = `${API_BASE}/scripts/update/:id`;
export const API_CALL_SCRIPT_DELETE = `${API_BASE}/scripts/delete`;
export const API_CALL_SCRIPT_SINGLE = `${API_BASE}/scripts/:id`;



export const API_DISPOSITION_LIST = `${API_BASE}/disposition-forms`;
export const API_DISPOSITION_GET_ONE = `${API_BASE}/disposition-forms/:id`;
export const API_DISPOSITION_CREATE = `${API_BASE}/disposition-forms`;
export const API_DISPOSITION_UPDATE = `${API_BASE}/disposition-forms/:id`;
export const API_DISPOSITION_DELETE = `${API_BASE}/disposition-forms/delete`;

export const API_DISPOSITION_FORM_DATA_CREATE = `${API_BASE}/disposition-form-data/`;

export const API_SYSTEM_MONITORING_STATS = `${API_BASE}/system-monitor`;

export const API_AGENT_CALL_STATUS_UPDATE = `${API_BASE}/agents/call-status`;

export const API_CALL_CENTER_UPDATE_CHANNEL_LICENCE = `${API_BASE}/agents/update-channel-licence`;

export const API_CREDIT_HISTORY_SUMMARY_OF_SPECIFIC_COMPANY = `${API_BASE}/credits/summary`;

export const API_LIST_OF_API_USERS = `${API_BASE}/api-users`;

export const API_BACKEND_LOGS = `${API_BASE}/logs/`;

export const API_HANGUP_CAUSES = `${API_BASE}/hangup-cause-codes`;

export const API_CERTS_EXPIRY_CHECKER = `${API_BASE}/certs-expiry/`